import {FaCube, FaGamepad, FaDatabase, FaUsers, FaNetworkWired, FaBoxOpen, FaUserPlus, FaIndustry, FaHospital, FaUniversity, FaRobot, FaChartBar, FaSeedling, FaPlaneDeparture, FaTruck, FaBriefcase } from 'react-icons/fa';

export const projects = [ 
    {
        id: 18,
        title: "Client IT & Website Projects",
        description: "End-to-end management of client IT and website development projects at CoreTech: requirements gathering, proposals and statements of work, scheduling, coordinating the development team, delivery and post-delivery support. Client details are confidential.",
        technologies: ["Project Planning", "Proposals & SOWs", "User Stories", "Stakeholder Management", "Delivery"],
        github: "",
        live: "",
        icon: <FaBriefcase className="text-white text-2xl" />,
        color: "from-gray-800 to-gray-600",
        role: "Managed",
        category: "IT Projects",
        year: "2026",
    },
    {
        id: 12,
        title: "Local RAG Assistant",
        description: "Retrieval-augmented question answering over CV documents: a FastAPI backend with /ask and streaming /ask-stream endpoints, a Pinecone retriever and LangChain (LCEL) chain, and a Streamlit front end.",
        technologies: ["Python", "FastAPI", "LangChain", "Pinecone", "Streamlit"],
        github: "https://github.com/TaimaHamadneh/Minimal-local-RAG",
        live: "",
        icon: <FaRobot className="text-white text-2xl" />,
        color: "from-pink-500 to-pink-300",
        role: "Built",
        category: "AI",
        year: "2026",
    },
    {
        id: 13,
        title: "RAG Chunking Evaluation",
        description: "Compares recursive, sentence-based and semantic chunking across several embedding models, scoring retrieval with Precision@k, Recall@k, MRR and nDCG@k.",
        technologies: ["Python", "LangChain", "Chroma", "sentence-transformers", "Pandas"],
        github: "https://github.com/TaimaHamadneh/Chunking-RAG-evaluation",
        live: "",
        icon: <FaChartBar className="text-white text-2xl" />,
        color: "from-mustard-500 to-mustard-300",
        role: "Built",
        category: "AI",
        year: "2026",
    },
    {
        id: 14,
        title: "Agriculture Advisory API",
        description: "Compares real-time sensor readings (temperature, humidity, CO2, soil moisture) against optimal ranges per crop stored in PostgreSQL and returns tailored farming advice.",
        technologies: ["FastAPI", "PostgreSQL", "Docker Compose", "Pandas", "Swagger"],
        github: "https://github.com/TaimaHamadneh/Agriculture-Advisory-API",
        live: "",
        icon: <FaSeedling className="text-white text-2xl" />,
        color: "from-coral-500 to-coral-300",
        role: "Built",
        category: "Backend API",
        year: "2026",
    },
    {
        id: 15,
        title: "Trip Tracker",
        description: "A Django app for planning trips and keeping travel notes, with authentication, trip CRUD, categorised notes, photo uploads and ratings.",
        technologies: ["Django", "Python", "Tailwind CSS", "Pillow"],
        github: "https://github.com/TaimaHamadneh/Trip-Trak-Project",
        live: "",
        icon: <FaPlaneDeparture className="text-white text-2xl" />,
        color: "from-pink-500 to-pink-300",
        role: "Built",
        category: "Full-Stack Web Application",
        year: "2026",
    },
    {
        id: 16,
        title: "Employee Facilitation System",
        description: "Contributed to the development of a real-world employee facilitation system delivered to a major bank.",
        technologies: ["Appian", "Low-Code"],
        github: "",
        live: "",
        icon: <FaUniversity className="text-white text-2xl" />,
        color: "from-mustard-500 to-mustard-300",
        role: "Built",
        category: "Banking System",
        year: "2025",
    },
    {
        id: 17,
        title: "Geem Logistic",
        description: "Graduation project: a management and e-commerce app where consumers order from several stores, merchants manage products and assign tasks to employees, and admins oversee everything from a dashboard with chat.",
        technologies: ["Flutter", "Node.js", "MongoDB", "Firebase"],
        github: "https://github.com/TaimaHamadneh/Geem-Logistic-",
        live: "",
        icon: <FaTruck className="text-white text-2xl" />,
        color: "from-coral-500 to-coral-300",
        role: "Built",
        category: "Mobile App",
        year: "2024",
    },
    {
        id: 10,
        title: "Turbo Game",
        description: "Turbo Game is an action-based desktop game developed with Unity and C#. Players utilize turbo boosts, strategic movement, and precision aiming to complete challenging levels.",
        technologies: [
            "Unity",
            "C#",
            "Itch.io",
        ],
        github: "",
        live: "https://taimahamadneh.itch.io/turbo-car",
        icon: <FaGamepad className="text-white text-2xl" />,
        color: "from-pink-500 to-pink-300",
        role: "Built",
        category: "Game",
        year: "2026",
    },
    {
        id: 11,
        title: "Flappy Bird",
        description: "A Unity-based Flappy Bird game where players guide a bird through obstacles, emphasizing precision and timing.",
        technologies: [
            "Unity",
            "C#",
            "Itch.io",
        ],
        github: "",
        live: "https://taimahamadneh.itch.io/flappy-bird",
        icon: <FaGamepad className="text-white text-2xl" />,
        color: "from-mustard-500 to-mustard-300",
        role: "Built",
        category: "Game",
        year: "2026",
    },
    {
        id: 1,
        title: "Coretech Telecom & ICT Website",
        description: "A corporate website for a telecommunications and ICT solutions provider specializing in telecom infrastructure, cybersecurity, and AI-driven software development.",
        technologies: [
            "React",
            "Responsive Design",
            "UI/UX",
            "Content Architecture"
        ],
        github: "",
        live: "https://www.coretechpal.com",
        icon: <FaNetworkWired className="text-white text-2xl" />,
        color: "from-coral-500 to-coral-300",        
        role: "Built",
        category: "Website",
        year: "2025",
    },
    {
        id: 2,
        title: "Sport Rubber Trading Website",
        description: "A corporate website for a rubber trading company focused on sports, industrial, and playground rubber solutions.",
        technologies: ["GoDaddy", "HTML", "CSS", "Responsive Design", "UI Content Structuring"],
        github: "",
        live: "https://sportrubber.com",
        icon: <FaIndustry className="text-white text-2xl" />,
        color: "from-pink-500 to-pink-300",
        role: "Built",
        category: "Website",
        year: "2025",
    },
    {
        id: 3,
        title: "Healthcare Management Application",
        description: "A full-stack healthcare management system that streamlines patient visits, treatments, and financial validation through role-based workflows.",
        technologies: [
            "MongoDB",
            "Express.js",
            "React",
            "Node.js",
            "REST API",
            "JWT Authentication",
            "Role-Based Access Control"
        ],
        github: "https://github.com/TaimaHamadneh/HealthCare-Application",
        live: "",
        icon: <FaHospital className="text-white text-2xl" />,
        color: "from-mustard-500 to-mustard-300",
        role: "Built",
        category: "Full-Stack Web Application",
        year: "2025",
    }, 
    {
        id: 4,
        title: "AR Menu Experience",
        description: "A modern web-based Augmented Reality (AR) restaurant menu that allows users to preview food items as interactive 3D models and view them in real-world AR before placing an order.",
        technologies: ["HTML", "CSS", "JavaScript", "model-viewer"],
        github: "https://github.com/TaimaHamadneh/AR-Model-Viewer-main",
        live: "https://taimahamadneh.github.io/AR-Model-Viewer-main/",
        icon: <FaCube className="text-white text-2xl" />,
        color: "from-coral-500 to-coral-300",
        role: "Built",
        category: "AR",
        year: "2025",
    },
      
    {
        id: 5,
        title: "Deposits Management System",
        description: "A fully integrated banking system built with Appian for managing deposits, transactions, and customer accounts with real-time processing.",
        technologies: ["Appian", "Low-Code"],
        github: "",
        live: "",
        icon: <FaDatabase className="text-white text-2xl" />,
        color: "from-pink-500 to-pink-300",      
        role: "Built",
        category: "Banking System",
        year: "2025",
    },
    {
        id: 6,
        title: "Team Member Management UI",
        description: "A clean and interactive front-end interface for managing team members with search, selection, and modal-based actions.",
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js",
            "UI/UX Design"
        ],
        github: "https://github.com/TaimaHamadneh/Registration-Form",
        live: "https://taimahamadneh.github.io/Registration-Form/",
        icon: <FaUsers className="text-white text-2xl" />,
        color: "from-mustard-500 to-mustard-300",
        role: "Built",
        category: "Front-End Application",
        year: "2023",
    },
    {
        id: 7,
        title: "Sign Up Page UI",
        description: "A clean and user-friendly sign-up form designed to collect user information with validation-ready input fields.",
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "Form Validation",
            "Responsive Design"
        ],
        github: "https://github.com/TaimaHamadneh/SignUp-Page",
        live: "https://taimahamadneh.github.io/SignUp-Page/",
        icon: <FaUserPlus className="text-white text-2xl" />,
        color: "from-coral-500 to-coral-300",
        role: "Built",
        category: "Front-End Application",
        year: "2023",
    },
    {
        id: 8,
        title: "CRUD Product Management System",
        description: "A front-end CRUD application for managing products with dynamic price calculation and advanced search functionality.",
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "Local Storage",
            "CRUD Operations"
        ],
        github: "https://github.com/TaimaHamadneh/Management-System",
        live: "https://taimahamadneh.github.io/Management-System/",
        icon: <FaBoxOpen className="text-white text-2xl" />,
        color: "from-pink-500 to-pink-300",        
        role: "Built",
        category: "Front-End Application",

        year: "2023",
    },
    {
        id: 9,
        title: "Tic-Tac-Toe Game",
        description: "A classic Tic-Tac-Toe game developed in Java with single-player and multiplayer modes and adjustable difficulty levels.",
        technologies: [
            "Java",
            "Object-Oriented Programming (OOP)",
            "Game Logic",
            "Algorithms"
        ],
        github: "https://github.com/TaimaHamadneh/Tic-Tac-Toe-Game",
        live: "",
        icon: <FaGamepad className="text-white text-2xl" />,
        color: "from-mustard-500 to-mustard-300",
        role: "Built",
        category: "Game",
        year: "2023",
    }
    
    
    
   
];

export const projectStats = {
    totalProjects: 15,
    featuredProjects: 6,
    technologiesUsed: 12,
    clientsServed: 8,
    satisfactionRate: "100%"
};